import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

const ManageMerchantHeader = () => {
  const { id } = useParams();
  return (
    <>
      <Back>
        <Link to="/admin/merchant">Back</Link>
      </Back>
      <StyledPageHeader>{id ? "Edit" : "Add"} User</StyledPageHeader>
    </>
  );
};
const Back = styled.div`
  padding: 0 1.5rem;
  padding-top: 1rem;
  > a {
    color: ${Colors.linkBlue};
  }
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;
const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default ManageMerchantHeader;
